module.exports = require("swagger-client");